import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const HomeSectionFooter: FCX = ({
    children,
    className,
    style,
    testId,
}) => {
    return (
        <div
            className={cn('HomeSectionFooter', className)}
            style={style}
            data-testid={testId}
        >
            {children}
        </div>
    );
};

export default HomeSectionFooter;